export default __webpack_public_path__ + "static/media/flag-unsc.558e6e2c.svg";